import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/twoFactor.svg'


const _hoisted_1 = { class: "modal twoFaPhoneModal" }
const _hoisted_2 = { class: "modal--content" }
const _hoisted_3 = { class: "modal--content-body" }
const _hoisted_4 = { class: "HeadingtextinfoDv" }
const _hoisted_5 = { class: "CustomCheckboxWrapper deleteDesclaimer" }
const _hoisted_6 = { class: "checkbox_wrapper widget" }
const _hoisted_7 = ["id", "value", "checked"]
const _hoisted_8 = { class: "checkboxLableDv" }
const _hoisted_9 = { class: "inputWithLabelDv" }
const _hoisted_10 = {
  key: 1,
  class: "verifyInfoChangeDv"
}
const _hoisted_11 = {
  key: 0,
  class: "numbError"
}
const _hoisted_12 = { class: "btninfoDv" }
const _hoisted_13 = {
  key: 0,
  class: "btn btn--primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal--backdrop",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dismiss()))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("figure", { class: "twoFaImg" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: ""
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t("setting.twoFactorAuth.title")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("setting.twoFactorAuth.description")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("input", {
              id: `info${_ctx.isSelectTwoFaType.isPhone}`,
              type: "checkbox",
              class: "custom-checkbox",
              value: _ctx.isSelectTwoFaType.isPhone,
              checked: _ctx.isSelectTwoFaType.isPhone,
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeStatus()))
            }, null, 40, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("setting.twoFactorAuth.phone")), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_vue_tel_input, {
            class: _normalizeClass([{ numbErrorBorder: _ctx.showErrorMessageNumberExist }, "WinningTradeinputDv"]),
            onValidate: _ctx.validatePhoneNumber,
            inputOptions: _ctx.options,
            onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.CheckingVerificationPhoneNumber(_ctx.userInfo.phoneNumber))),
            modelValue: _ctx.userInfo.phoneNumber,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userInfo.phoneNumber) = $event)),
            validCharactersOnly: true,
            mode: "international"
          }, _createSlots({ _: 2 }, [
            (_ctx.showFirbaseVerification)
              ? {
                  name: "icon-right",
                  fn: _withCtx(() => [
                    (!_ctx.userInfo.isPhoneVerified)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "verifyInfoChangeDv",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openPhoneNumberVerificationPopup()))
                        }, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t("setting.common.verify")), 1)
                        ]))
                      : (_ctx.userInfo.phoneNumber?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t("setting.common.verified")), 1)
                          ]))
                        : _createCommentVNode("", true)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["class", "onValidate", "inputOptions", "modelValue"]),
          (_ctx.showErrorMessageNumberExist)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t("setting.twoFactorAuth.numberExists")), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("button", _hoisted_13, _cache[7] || (_cache[7] = [
                _createElementVNode("div", { class: "loader" }, null, -1)
              ])))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: _normalizeClass(["btn btn--primary", { disabled: _ctx.btnDisabled }]),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitPhoneNumber()))
              }, _toDisplayString(_ctx.$t("common.actions.submit")), 3)),
          _createElementVNode("button", {
            class: "btn btn--outline",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dismiss()))
          }, _toDisplayString(_ctx.$t("common.actions.cancel")), 1)
        ])
      ])
    ])
  ], 512)), [
    [_vShow, !_ctx.hideCurrentModal]
  ])
}